import { getActionFromPath } from "../../WarehouseOutWard/utils";
import { isSaleSourceType } from "../config/saleKinds";

export type OutwardAction = "CREATE" | "EDIT" | "DETAIL" | "";

export interface OutwardRouteInput {
  pathname: string;
  /** location.state của react-router, có thể null khi mở ở tab mới hoặc F5 */
  state: unknown;
  /** location.search, ví dụ "?transactionCode=XK001&type=XUAT_BAN" */
  search: string;
}

export interface OutwardRoute {
  action: OutwardAction;
  sourceType: string | null;
  sourceCode: string | null;
  transactionCode: string | null;
  id: number | string | null;
  isLocked: boolean;
  /** true khi phiếu do trang xuất bán xử lý (XUAT_BAN, XUAT_DOI_TRA) */
  isSale: boolean;
}

type RouteState = {
  sourceCode?: string | null;
  sourceType?: string | null;
  type?: string | null;
  transactionCode?: string | null;
  isLocked?: boolean | null;
  id?: number | string | null;
};

const asRouteState = (state: unknown): RouteState | null =>
  state && typeof state === "object" ? (state as RouteState) : null;

/**
 * Đọc tham số của 3 route create/edit/detail-warehouse-out-ward.
 * Thứ tự ưu tiên giữ đúng như WarehouseOutWardActionV2 đang đọc, vì khoảng 25 chỗ trong app
 * điều hướng vào đây bằng location.state, riêng lịch sử barcode mở tab mới bằng query string.
 */
export const resolveOutwardRoute = ({
  pathname,
  state,
  search,
}: OutwardRouteInput): OutwardRoute => {
  const routeState = asRouteState(state);
  const query = new URLSearchParams(search);

  const sourceType =
    routeState?.sourceType ||
    routeState?.type ||
    query.get("sourceType") ||
    query.get("type") ||
    null;

  return {
    action: getActionFromPath(pathname) as OutwardAction,
    sourceType,
    // sourceCode chỉ đến từ state (màn phiếu cần xuất), không đọc query
    sourceCode: routeState?.sourceCode || null,
    transactionCode: routeState?.transactionCode ?? query.get("transactionCode"),
    // isLocked: false trong state vẫn được giữ, chỉ rơi xuống query khi state không có giá trị
    isLocked: routeState?.isLocked ?? query.get("isLocked") === "true",
    id: routeState?.id ?? null,
    isSale: isSaleSourceType(sourceType),
  };
};
